import { Box, styled } from '@mui/material';

export const PaletteRoot = styled(Box)(({ theme }) => ({
  '& [cmdk-input]': {
    width: '100%',
    boxSizing: 'border-box',
    border: 'none',
    outline: 'none',
    background: 'transparent',
    color: theme.palette.text.primary,
    fontFamily: theme.typography.fontFamily,
    fontSize: 15,
    padding: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.divider}`,
    '&::placeholder': {
      color: theme.palette.text.secondary,
    },
  },
  '& [cmdk-list]': {
    maxHeight: 360,
    overflowY: 'auto',
    padding: theme.spacing(1),
  },
  '& [cmdk-group-heading]': {
    color: theme.palette.text.secondary,
    fontSize: 11,
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    padding: theme.spacing(1, 1, 0.5),
  },
  '& [cmdk-item]': {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    padding: theme.spacing(1, 1.5),
    borderRadius: theme.shape.borderRadius,
    cursor: 'pointer',
    color: theme.palette.text.primary,
    fontSize: 13,
    '& svg': {
      color: theme.palette.text.secondary,
    },
  },
  '& [cmdk-item][data-selected="true"]': {
    backgroundColor: theme.palette.action.hover,
  },
  '& [cmdk-empty]': {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    fontSize: 13,
  },
}));

export const PaletteFooter = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  padding: theme.spacing(0.75, 2),
  borderTop: `1px solid ${theme.palette.divider}`,
}));
